import {SectionSkeleton} from '../../../models/form/SectionSkeleton';
import {ConfigurationRules} from '../../../models/form/ConfigurationRules';
import {IFormConfiguration} from '../../../models/form/FormConfiguration';
import {EditingRights} from '../../../models/form/EditingRights';

/**
 * Prepares the input to submit to the backend
 * @param sections List of sections
 * @param rules Configuration rules
 * @param editingRights Number of operations available to users for the current configuration
 * @param instructions Fill-in instructions
 */
export function prepareFormInput(
  sections: SectionSkeleton[],
  rules: ConfigurationRules,
  editingRights: EditingRights,
  instructions?: string,
): IFormConfiguration {
  return {
    sections: sections.map((section) => {
      const fields = section.fields.map((field) => ({
        id: field.id,
        required: field.required,
      }));
      return {
        id: section.id,
        fields,
      };
    }),
    instructions,
    rules: {
      freePaidStatus: rules.freePaidStatus,
      defaultLanguage: rules.defaultLanguage,
      privatePublicStatus: rules.privatePublicStatus,
      eventTypeIds: rules.eventTypeIds,
    },
    editingRights
  };
}
